import React, { useState, useEffect, useRef } from "react";
import { useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { hikerGenderState } from "../../atom/atom";
import { useRecoilValue } from "recoil";
import useWindowDimensions from "../../hooks/useWindowDimensions";
import firebase from "../../firebase.js";
import { isAndroid, isIOS, withOrientationChange } from "react-device-detect";

import ModelViewer from "./MainPageItem/ModelViewer";
import SliderBar from "./MainPageItem/SliderBar";
import SliderModal from "./MainPageItem/SliderModal";
import ErrorModal from "./MainPageItem/ErrorModal";

import "./styles/Mainpage.css";
import styled from "styled-components";

import {
    StyledWrapper,
    ModelWrapper,
    SliderWrapper,
} from "./styles/Mainpage-styled.js";

import Grid from "@material-ui/core/Grid";

import LoadingPage from "../LoadingPage";
import LandscapeErrorPage from "../ErrorPage/LandscapeErrorPage";

const Wrapper = styled.div`
    ${StyledWrapper};
`;

const MainPage = (props) => {
    let { characterName } = useParams();
    const characterId = props.location.search;
    const { height } = useWindowDimensions();
    let vh = height * 0.01;
    const { isLandscape } = props;
    const { t, i18n } = useTranslation();
    const hikerGender = useRecoilValue(hikerGenderState);

    const [isLoading, setIsLoading] = useState(true);
    const [model, setModel] = useState("");
    const [iosModel, setIosModel] = useState("");
    const [modelState, setModelState] = useState("");
    const [textState, setTextState] = useState("");
    const [textLinkState, setTextLinkState] = useState(null);
    const [linkState, setLinkState] = useState(null);
    const [linkColorState, setLinkColorState] = useState("");
    const [storeURL, setStoreURL] = useState("");

    const [value, setValue] = useState(0);
    const [count, setCount] = useState(0);
    const [open, setOpen] = useState(false);
    const [openError, setErrorOpen] = useState(false);
    const [defaultImageLoaded, setdefaultImageLoaded] = useState(false);
    const [annotationBg, setAnnotationBg] = useState("");
    const [arButtonState, setArButtonState] = useState("flex");
    const [modelLazyImage, setModelLazyImage] = useState("");
    const [neonImage, setNeonImage] = useState("");
    const [teaCupImage, setTeaCupImage] = useState("");
    const [fishBallImage, setFishballImage] = useState("");
    const [hikerImage, setHikerImage] = useState("");
    const [lionImage, setLionImage] = useState("");
    const [ferryImage, setFerryImage] = useState("");

    const neonRef = useRef(null);
    const teaCupRef = useRef(null);
    const fishBallRef = useRef(null);
    const hikerRef = useRef(null);
    const lionRef = useRef(null);
    const ferryRef = useRef(null);
    const modelViewerRef = useRef(null);

    const [nameRestaurant, setNameRestaurant] = useState(null);

    useEffect(() => {
        const imageLoader = async () => {
            const neonData = await import(
                "../../assets/sliderbar/unselected/Neon_locked.png"
            );
            setNeonImage(neonData.default);
            const teaCupData = await import(
                "../../assets/sliderbar/unselected/Teacup_locked.png"
            );
            setTeaCupImage(teaCupData.default);
            const fishBallData = await import(
                "../../assets/sliderbar/unselected/Fishballs_locked.png"
            );
            setFishballImage(fishBallData.default);

            const hikerData = await import(
                "../../assets/sliderbar/unselected/Hikers_locked.png"
            );
            setHikerImage(hikerData.default);

            const lionData = await import(
                "../../assets/sliderbar/unselected/Lion_locked.png"
            );
            setLionImage(lionData.default);
            const ferryData = await import(
                "../../assets/sliderbar/unselected/Ferry_locked.png"
            );
            setFerryImage(ferryData.default);
            setdefaultImageLoaded(true);
        };
        imageLoader();

        if (isIOS) {
            setStoreURL("https://hojengar.page.link/app_download_ios");
        } else if (isAndroid) {
            setStoreURL("https://hojengar.page.link/app_download_android");
        } else {
            setStoreURL("https://hojengar.page.link/app_download");
        }
        setModelState(characterName);
    }, [characterName]);

    useEffect(() => {
        if (characterId === "") {
            setTextState(
                t(
                    "mainPage.text.defaultAnnotationText",
                    "Special message or deal goes here\n(This box contains 64 characters)"
                )
            );
        } else {
            const CharacterId = characterId.slice(1);
            const docRef = firebase
                .firestore()
                .collection("vip")
                .doc(CharacterId);

            docRef
                .get()
                .then(function (doc) {
                    if (doc.exists) {
                        // console.log("Document data:", doc.data());

                        const linkAnnotation = doc.data().link;
                        setLinkState(linkAnnotation);

                        setNameRestaurant(doc.data().name);
                        if (i18n.language === "zh") {
                            const annotation = doc
                                .data()
                                .zh_quote.replace("\\n", "\n");
                            const textLinkAnnotation = doc.data()
                                .zh_link_string;
                            setTextState(annotation);
                            setTextLinkState(textLinkAnnotation);
                        } else {
                            const annotation = doc
                                .data()
                                .en_quote.replace("\\n", "\n");
                            const textLinkAnnotation = doc.data()
                                .en_link_string;
                            setTextState(annotation);
                            setTextLinkState(textLinkAnnotation);
                        }
                    } else {
                        // doc.data() will be undefined in this case
                        console.log("No such document!");
                    }
                })
                .catch(function (error) {
                    console.log("Error getting document:", error);
                });
        }
    }, [characterId, t, i18n.language]);

    useEffect(() => {
        if (defaultImageLoaded) {
            const selectedImageLoader = async (
                selectedImage,
                callBackSetImage
            ) => {
                const selectedData = await import(
                    `../../assets/sliderbar/selected/${selectedImage}.png`
                );
                const bgData = await import(
                    `../../assets/annotation_bg/${selectedImage}_bg.png`
                );
                const modelLazyData = await import(
                    `../../assets/lazy_poster/${selectedImage}_lazy.png`
                );

                callBackSetImage(selectedData.default);
                setModelLazyImage(modelLazyData.default);
                setAnnotationBg(bgData.default);
                setCount(1);
            };

            switch (modelState) {
                case "neon":
                    setModel("../../assets/ar_model/Neon/Neon.glb");
                    setIosModel(
                        "../../assets/ar_model/Neon/Neon_Animation_WebVersion_v05.usdz"
                    );
                    setValue(0);
                    selectedImageLoader("Neon_unlocked_selected", setNeonImage);
                    setLinkColorState("#B764FF");
                    break;
                case "milk_tea":
                    setModel("../../assets/ar_model/Milk_Tea/MilkTea.glb");
                    setIosModel(
                        "../../assets/ar_model/Milk_Tea/MilkTea_Animation_WebVersion_v04.usdz"
                    );
                    setValue(1);
                    selectedImageLoader(
                        "Teacup_unlocked_selected",
                        setTeaCupImage
                    );
                    setLinkColorState("#FF72D9");
                    break;
                case "fishballs":
                    setModel("../../assets/ar_model/Fishballs/Fishballs.glb");
                    setIosModel(
                        "../../assets/ar_model/Fishballs/Fishballs_Animation_WebVersion_v05.usdz"
                    );
                    setValue(2);
                    selectedImageLoader(
                        "Fishballs_unlocked_selected",
                        setFishballImage
                    );
                    setLinkColorState("#DB7A00");
                    break;
                case "hiker_twins":
                    setValue(3);
                    setLinkColorState("#81CA52");
                    if (hikerGender === "hiker_boys") {
                        setModel(
                            "../../assets/ar_model/Hiker_boys/HikerBoy.glb"
                        );
                        setIosModel(
                            "../../assets/ar_model/Hiker_boys/HikerBoy.usdz"
                        );
                        selectedImageLoader(
                            "Hikers_boys_unlocked_selected",
                            setHikerImage
                        );
                    } else {
                        setModel(
                            "../../assets/ar_model/Hiker_girls/HikerGirl.glb"
                        );
                        setIosModel(
                            "../../assets/ar_model/Hiker_girls/HikerGirl.usdz"
                        );
                        selectedImageLoader(
                            "Hikers_girls_unlocked_selected",
                            setHikerImage
                        );
                    }
                    break;
                case "lion":
                    setModel("../../assets/ar_model/Lion/Lion.glb");
                    setIosModel(
                        "../../assets/ar_model/Lion/Lion_Animation_WebVersion-Dance_v05.usdz"
                    );
                    setValue(4);
                    selectedImageLoader("Lion_unlocked_selected", setLionImage);
                    setLinkColorState("#DA0023");
                    break;
                case "ferry":
                    setModel("../../assets/ar_model/Ferry/Ferry.glb");
                    setIosModel(
                        "../../assets/ar_model/Ferry/Ferry_Animation_WebVersion_v05.usdz"
                    );
                    setValue(5);
                    selectedImageLoader(
                        "Ferry_unlocked_selected",
                        setFerryImage
                    );
                    setLinkColorState("#7BD6E0");
                    break;
                default:
                    break;
            }
        }
    }, [modelState, defaultImageLoaded, hikerGender]);

    useEffect(() => {
        const ModelViewerRef = modelViewerRef.current;
        const arStatusHandler = (ev) => {
            if (ev.detail.status === "not-presenting") {
                setArButtonState("flex");
            } else {
                setArButtonState("none");
            }
        };
        if (ModelViewerRef) {
            ModelViewerRef.addEventListener("ar-status", arStatusHandler);
        }
        return () => {
            if (ModelViewerRef) {
                ModelViewerRef.removeEventListener(
                    "ar-status",
                    arStatusHandler
                );
            }
        };
    }, [modelViewerRef]);

    const handleOnLoad = () => {
        if (neonRef.current !== null) {
            if (count === 1) {
                setIsLoading(false);
            }
        } else if (teaCupRef.current !== null) {
            if (count === 1) {
                setIsLoading(false);
            }
        } else if (fishBallRef.current !== null) {
            if (count === 1) {
                setIsLoading(false);
            }
        } else if (hikerRef.current !== null) {
            if (count === 1) {
                setIsLoading(false);
            }
        } else if (lionRef.current !== null) {
            if (count === 1) {
                setIsLoading(false);
            }
        } else if (ferryRef.current !== null) {
            if (count === 1) {
                setIsLoading(false);
            }
        }
    };

    const handleOpen = (e) => {
        if (e.target.alt === modelState) {
            return "";
        } else {
            setOpen(true);
        }
    };

    const handleClose = () => {
        setOpen(false);
    };

    const handleErrorClose = () => {
        window.location.reload(false);
    };

    const onChange = (value) => {
        setValue(value);
    };

    const handleActivateAR = async () => {
        try {
            const activator = await modelViewerRef.current.activateAR();
            if (isAndroid) {
                setArButtonState("none");
            }
        } catch (err) {
            console.log(err);
            // console.log(String(err).slice(0,1));
            if (err) {
                setErrorOpen(true);
            }
        }
    };

    if (isLandscape) {
        return <LandscapeErrorPage />;
    }
    return (
        <div>
            {isLoading ? <LoadingPage /> : <div />}
            <Grid
                container
                direction="column"
                justify="center"
                alignItems="center"
                style={isLoading ? { display: "none" } : null}
            >
                <Wrapper vh={vh}>
                    <ModelWrapper>
                        <ModelViewer
                            modelLazyImage={modelLazyImage}
                            model={model}
                            iosModel={iosModel}
                            modelViewerRef={modelViewerRef}
                            handleActivateAR={handleActivateAR}
                            arButtonState={arButtonState}
                            annotationBg={annotationBg}
                            textState={textState}
                            textLinkState={textLinkState}
                            linkState={linkState}
                            linkColorState={linkColorState}
                        />
                    </ModelWrapper>
                    <SliderWrapper>
                        <SliderBar
                            value={value}
                            onChange={onChange}
                            handleOpen={handleOpen}
                            handleOnLoad={handleOnLoad}
                            neonImage={neonImage}
                            neonRef={neonRef}
                            teaCupImage={teaCupImage}
                            teaCupRef={teaCupRef}
                            fishBallImage={fishBallImage}
                            fishBallRef={fishBallRef}
                            hikerImage={hikerImage}
                            hikerRef={hikerRef}
                            lionImage={lionImage}
                            lionRef={lionRef}
                            ferryImage={ferryImage}
                            ferryRef={ferryRef}
                        />
                    </SliderWrapper>
                    <SliderModal
                        open={open}
                        handleClose={handleClose}
                        storeURL={storeURL}
                        nameRestaurant={nameRestaurant}
                        isIOS={isIOS}
                        isAndroid={isAndroid}
                    />
                    <ErrorModal
                        openError={openError}
                        handleErrorClose={handleErrorClose}
                    />
                </Wrapper>
            </Grid>
        </div>
    );
};

export default withOrientationChange(MainPage);
